import React from "react";
import { useTranslation } from "react-i18next";

export default function AddScopeButton(props: { onClick: () => void }) {
	const { t } = useTranslation();

	return <div className="text-align-right">
		<button type="button" className="qd-btn qd-btn-primary" onClick={props.onClick}>
			{t("control.relation.addScope")}
		</button>
	</div>
}
